import React from 'react'

import DocumentResults from './results/DocumentResults'
import FAQResults from './results/FAQResults'
import GenAIResult from './results/GenAIResult'
import TopResults from './results/TopResults'

/**
 * Component for displaying various types of search results.
 *
 * @see {@link https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/resultsPanel resultPanel dir - AWS Samples}
 * @param {Object} props - The component props.
 * @param {boolean} props.dataReady - Indicates if the data is ready to be displayed.
 * @param {Object} props.results - The search results.
 * @param {Array} props.topResults - The top search results.
 * @param {Array} props.faqResults - The FAQ search results.
 * @param {Array} props.docResults - The document search results.
 * @param {Function} props.submitFeedback - The function to submit feedback for a result.
 * @param {Array} props.selectedFacets - The selected facets for filtering results.
 * @param {string} props.queryText - The search query text.
 * @param {Object} props.extendedResults - The extended search results.
 * @param {boolean} [props.showGenAIResult=false] - Whether to show the GenAI result.
 * @param {boolean} [props.showTopResults=false] - Whether to show the top results.
 * @param {boolean} [props.showFAQResults=false] - Whether to show the FAQ results.
 * @param {boolean} [props.showDocumentResults=true] - Whether to show the document results.
 * @returns {JSX.Element|null} The rendered component or null if data is not ready.
 */
const ResultsPanel = ({
  dataReady,
  results,
  topResults,
  faqResults,
  docResults,
  submitFeedback,
  selectedFacets,
  queryText,
  extendedResults,
  showGenAIResult,
  showTopResults,
  showFAQResults,
  showDocumentResults
}) => {
  if (dataReady) {
    return (
      <>
        {showGenAIResult && (
          <GenAIResult
            selectedFacets={selectedFacets}
            queryText={queryText}
            retrieveAPI={extendedResults}
            queryAPI={results}
          />
        )}
        {showTopResults && (
          <TopResults results={topResults} submitFeedback={submitFeedback} />
        )}
        {showFAQResults && (
          <FAQResults results={faqResults} submitFeedback={submitFeedback} />
        )}
        {showDocumentResults && (
          <DocumentResults
            results={docResults}
            submitFeedback={submitFeedback}
          />
        )}
      </>
    )
  }
  return null
}

export default ResultsPanel
